import { fetchPoolProxies } from '@fd/common/api/fetchPoolProxies';
import useOrder from '@fd/frontend/hooks/queries/useOrder';
import usePoolById from '@fd/frontend/hooks/queries/usePoolById';
import { useTrafficGbAvailableByProxyType } from '@fd/frontend/hooks/useTrafficAvailableByProxyType';
import useSWR from 'swr';

export default function useProxiesInPool(poolId: number) {
  const { data, isLoading, error, mutate } = useSWR(['proxies', poolId], () =>
    fetchPoolProxies(poolId)
  );

  const { data: pool } = usePoolById(poolId);
  const orders = useOrder();
  const availableTraffic = useTrafficGbAvailableByProxyType(
    pool?.proxy_type ?? 'residential'
  );
  const isHideCredential =
    (orders.length === 0 && (availableTraffic === 0 || !availableTraffic));

  // if (isHideCredential) {
  //   data?.forEach((proxy) => {
  //     proxy.username = proxy.username.replace(/(?<=.{8})./g, '*');
  //     proxy.password = proxy.password.replace(/(?<=.{8})./g, '*');
  //   });
  // }

  return {
    data,
    isLoading,
    error,
    mutate,
    isHideCredential,
  };
}
